import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ISuccessStepProps } from '../../types';
import { CHANNEL_INFO, T_KEYS } from '../../constants';
import {
  SuccessBanner,
  SuccessLogos,
  SuccessCheckmark,
  SuccessContent,
  SuccessTitle,
  SuccessDescription,
} from '../../styles';

// Import unified channel logo components
import { ChannelLogo, MsoolLogo, ChannelLogoType } from '../ChannelLogos';

const SuccessStep: FC<ISuccessStepProps> = memo(({
  channelName,
  onImportNow,
  onImportLater,
}) => {
  const { t, i18n } = useTranslation();
  const isRtl = i18n.language === 'ar';

  const channelInfo = CHANNEL_INFO[channelName];
  const displayName = isRtl ? channelInfo.displayNameAr : channelInfo.displayName;

  // Map channelName to ChannelLogoType
  const channelLogoType: ChannelLogoType = channelName as ChannelLogoType;

  return (
    <SuccessBanner>
      <SuccessContent>
        <SuccessTitle>
          {t(T_KEYS.CONNECTION_SUCCESS, { channel: displayName })}
        </SuccessTitle>
        <SuccessDescription>
          {t(T_KEYS.CONNECTION_SUCCESS_DESC, { channel: displayName })}
        </SuccessDescription>
      </SuccessContent>
      <SuccessLogos>
        <MsoolLogo size="xl" rounded />
        <SuccessCheckmark>
          <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_1_11237)">
              <rect x="3.80957" y="3.80951" width="18.2857" height="18.2857" rx="9.14286" fill="white"/>
              <path d="M18.065 9.30282C17.9941 9.23141 17.9099 9.17473 17.817 9.13605C17.7242 9.09737 17.6246 9.07745 17.524 9.07745C17.4234 9.07745 17.3238 9.09737 17.231 9.13605C17.1381 9.17473 17.0539 9.23141 16.9831 9.30282L11.3069 14.9866L8.9221 12.5943C8.84856 12.5232 8.76175 12.4674 8.66662 12.4299C8.57149 12.3924 8.46991 12.374 8.36768 12.3758C8.26545 12.3775 8.16456 12.3994 8.07079 12.4402C7.97701 12.4809 7.89219 12.5398 7.82115 12.6133C7.75011 12.6868 7.69425 12.7737 7.65676 12.8688C7.61927 12.9639 7.60089 13.0655 7.60266 13.1677C7.60442 13.27 7.62631 13.3708 7.66707 13.4646C7.70783 13.5584 7.76665 13.6432 7.84019 13.7143L10.7659 16.64C10.8367 16.7114 10.921 16.7681 11.0139 16.8067C11.1067 16.8454 11.2063 16.8653 11.3069 16.8653C11.4074 16.8653 11.507 16.8454 11.5999 16.8067C11.6927 16.7681 11.777 16.7114 11.8478 16.64L18.065 10.4228C18.1423 10.3515 18.204 10.2649 18.2462 10.1685C18.2884 10.0721 18.3102 9.96804 18.3102 9.86282C18.3102 9.7576 18.2884 9.65352 18.2462 9.55714C18.204 9.46076 18.1423 9.37417 18.065 9.30282Z" fill="#06C270"/>
            </g>
            <defs>
              <filter id="filter0_d_1_11237" x="4.64916e-05" y="-1.45435e-05" width="25.9052" height="25.9048" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset/>
                <feGaussianBlur stdDeviation="1.90476"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1_11237"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1_11237" result="shape"/>
              </filter>
            </defs>
          </svg>
        </SuccessCheckmark>
        <ChannelLogo channel={channelLogoType} size="xl" rounded />
      </SuccessLogos>
    </SuccessBanner>
  );
});

SuccessStep.displayName = 'SuccessStep';

export default SuccessStep;
